export default __webpack_public_path__ + "static/media/2013-IMcover.90bdb8c1.jpg";